import { useMutation } from '@tanstack/react-query';
import { linkBusinessStripeAccount } from '../../services/business';
import { LinkStripeAccountDto } from '../../types/stripe';
import useUser from '../global/useUser';
import { LoadedUser } from '../../interfaces';

interface UseLinkStripeAccountProps {
  onError?: (error: Error) => void;
}

function useLinkStripeAccount({ onError }: UseLinkStripeAccountProps = {}) {
  const { user } = useUser<LoadedUser>();

  return useMutation({
    mutationFn: async (payload: LinkStripeAccountDto) => {
      if (!user?.business?.id) return null;
      const result = await linkBusinessStripeAccount(user.business.id, payload);
      return result;
    },
    onError,
  });
}

export default useLinkStripeAccount;
